import logoWhite from './assets/images/harlan-logo-white.png';
import logoBlack from './assets/images/harlan-logo-black.png';
import promoPhoto from './assets/images/harlan-barn.jpg';
import promoPhotoBw from './assets/images/harlan-barn-bw.jpg';
import promoPhotoSepia from './assets/images/harlan-barn-sep.jpg';
import jonPhoto from './assets/images/jon-barn.jpg';
import pricingSheet from './assets/images/harlan-event-pricing.pdf';

export type Show = {
  date: string;
  venue: string;
  location: string;
  note?: string;
};

export type Download = {
  label: string;
  file: string;
  description: string;
};

export const shows: Show[] = [
  { date: 'JAN 18 · Roseville, CA', venue: 'Goldfield Trading Post', location: 'Co-headline w/ special guest' },
  { date: 'FEB 08 · Sacramento, CA', venue: 'The Guild Theater', location: 'Nashville Nights Series' },
  { date: 'MAR 14 · Chico, CA', venue: 'The Sierra Nevada Big Room', location: '90s Country Throwdown' },
  { date: 'APR 12 · Yuba City, CA', venue: 'Sutter Theater Center for the Arts', location: 'Concert for a Cause' },
  { date: 'MAY 24 · Napa, CA', venue: 'BottleRock Late Night', location: 'Official Afterparty' },
];

export const downloads: Download[] = [
  { label: 'Press Photo (Color)', file: promoPhoto, description: 'Hi-res 5K JPG' },
  { label: 'Press Photo (B&W)', file: promoPhotoBw, description: 'Hi-res 5K JPG' },
  { label: 'Press Photo (Sepia)', file: promoPhotoSepia, description: 'Hi-res 5K JPG' },
  { label: 'Lead Vocalist Portrait', file: jonPhoto, description: 'Jon Harlan portrait' },
  { label: 'Logo (White)', file: logoWhite, description: 'Transparent PNG' },
  { label: 'Logo (Black)', file: logoBlack, description: 'Transparent PNG' },
  { label: 'Booking One Sheet', file: pricingSheet, description: 'PDF · Rates & capabilities' },
];

export const navItems = [
  { href: '/about', label: 'About' },
  { href: '/shows', label: 'Shows' },
  { href: '/media', label: 'Media' },
  { href: '/epk', label: 'EPK' },
  { href: '/contact', label: 'Contact' },
] as const;
